var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPivot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.697,
    height: 53.587,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 37532"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 17548",
    fill: "#5ed142",
    d: "M0 14.96h11.033v38.614H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 17549",
    fill: "#ff5d48",
    d: "M14.925 11.033V0h38.614v11.033z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 17550",
    fill: "#ffdb4d",
    d: "M0 11.068V.035h11.033v11.033z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21776",
    d: "m53.131 23.634-6.791-6.791a1.946 1.946 0 0 0-2.752 0l-6.791 6.791a1.946 1.946 0 0 0 2.752 2.752l3.469-3.469v13.521c0 3.566-2.568 6.467-5.724 6.467H24.972l3.469-3.469a1.946 1.946 0 1 0-2.752-2.752l-6.791 6.791a1.946 1.946 0 0 0 0 2.752l6.791 6.791a1.946 1.946 0 1 0 2.752-2.752l-3.469-3.469h12.322c5.3 0 9.616-4.647 9.616-10.359V22.917l3.469 3.469a1.946 1.946 0 0 0 2.752-2.752Z",
    fill: "#2d3e5c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPivot);
export default __webpack_public_path__ + "static/media/pivot.20ea238d0f89013205c03d307f7f5c68.svg";
export { ForwardRef as ReactComponent };